import mapboxgl from 'mapbox-gl';

export const addMapSources = (
  map: mapboxgl.Map,
  {
    slotMapJsonWithIds,
    wallMapJson,
    labelMapJson,
    bankIdMapJson,
  }: {
    slotMapJsonWithIds: GeoJSON.FeatureCollection | null;
    wallMapJson: GeoJSON.FeatureCollection | null;
    labelMapJson: GeoJSON.FeatureCollection | null;
    bankIdMapJson: GeoJSON.FeatureCollection | null;
  }
) => {
  // Slot Source
  if (slotMapJsonWithIds?.features) {
    map.addSource('slotSource', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: slotMapJsonWithIds.features,
      },
    });
  }

  // Wall Source
  if (wallMapJson?.features) {
    map.addSource('wallSource', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: wallMapJson.features,
      },
    });
  }

  // Label Source
  if (labelMapJson?.features) {
    labelMapJson.features.forEach((feature) => {
      const props = feature.properties;
      if (props && typeof props.autocad_text_string === 'string') {
        props.autocad_text_string = props.autocad_text_string.replace(/\\n/g, '\n');
      }
    });

    map.addSource('labelSource', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: labelMapJson.features,
      },
    });
  }

  // Bank ID Source
  if (bankIdMapJson?.features) {
    map.addSource('bankIdSource', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: bankIdMapJson.features,
      },
    });
  }
};
